(function ($) {
    $.fn.naisSideDialog = function() {
        let URL_PARAM_NAME = 'naisSideDialog'; // parameter name in URL when history is enabled
        let SNIPPET_ID = 'snippet--nais-side-dialog'; // id of element for nette snippet
        /** @type {readonly string[]} */
        let VALID_SIZES = ['wide', 'half', 'compact', 'modal'];
        let SIZE_CLASSES = VALID_SIZES.map((size) => 'nais-sd-window--' + size);

        let historyEnabled = false; // enable history modifying (history pushState)

        let events = {};

        // jQuery elements
        let $background;
        let $window;
        let $closeButton;
        let $snippet;

        let dialog = this;
        let lastOpenTrigger = null;

        /**
         * Hide/dispose Bootstrap 5 tooltips before the panel covers the trigger.
         * @param {JQuery|HTMLElement|null|undefined} $trigger
         */
        function hideOpenTooltips($trigger) {
            if (typeof window.hideBootstrapTooltips === 'function') {
                window.hideBootstrapTooltips();
            }

            // BS5 tip nodes use .tooltip.show (legacy looked for .tooltip.in)
            $('body > .tooltip').remove();

            let $el = $trigger && $trigger.jquery ? $trigger : $($trigger || []);
            if (!$el.length) {
                return;
            }

            $el.add($el.find('[data-bs-toggle="tooltip"], [title], [data-bs-title]')).each(function hideEach() {
                try {
                    if ($(this).tooltip) {
                        // hide only — dispose races with Bootstrap's queued show/hide callback
                        $(this).tooltip('hide');
                    }
                } catch (e) {
                    /* ignore */
                }
            });

            $el.trigger('blur');
            if ($el[0] && typeof $el[0].blur === 'function') {
                $el[0].blur();
            }
        }

        /**
         * Host element for the AJAX snippet — always inside the side panel.
         * @returns {JQuery}
         */
        function getSnippetHost() {
            return $('.nais-sd-container #' + SNIPPET_ID);
        }

        /**
         * Nette may insert #snippet--nais-side-dialog into .nais-content (layout);
         * move content into the panel and remove duplicates.
         */
        function relocateSideDialogSnippet() {
            let $host = getSnippetHost();
            if (!$host.length) {
                return;
            }

            $('#' + SNIPPET_ID).not($host).each(function () {
                let $foreign = $(this);
                let html = $foreign.html();
                if (html && $.trim(html).length > 0) {
                    $host.html(html);
                }
                $foreign.remove();
            });
        }

        /**
         * @param {*} raw
         * @returns {'wide'|'compact'|null}
         */
        function normalizeSize(raw) {
            if (typeof raw !== 'string') {
                return null;
            }
            return VALID_SIZES.indexOf(raw) !== -1 ? raw : null;
        }

        /**
         * @param {JQuery|HTMLElement|undefined} element
         * @returns {'wide'|'compact'|null}
         */
        function readSizeFromElement(element) {
            if (!element) {
                return null;
            }
            let $el = element instanceof $ ? element : $(element);
            if (!$el.length) {
                return null;
            }
            return normalizeSize($el.data('naisSdSize') || $el.data('nais-sd-size') || $el.attr('data-nais-sd-size'));
        }

        /**
         * Resolve size from the loaded snippet — data-nais-sd-size or .nais-sd-panel--{wide|compact}.
         * @returns {'wide'|'compact'|null}
         */
        function resolveSizeFromSnippet() {
            relocateSideDialogSnippet();

            let $scope = $('.nais-sd-container');
            if (!$scope.length) {
                return null;
            }

            let $root = getSnippetHost();
            if ($root.length) {
                let fromData = readSizeFromElement($root);
                if (fromData) {
                    return fromData;
                }
            }

            let $marked = $scope.find('[data-nais-sd-size]').first();
            let fromData = readSizeFromElement($marked);
            if (fromData) {
                return fromData;
            }

            for (let i = 0; i < VALID_SIZES.length; i++) {
                let size = VALID_SIZES[i];
                if ($scope.find('.nais-sd-panel--' + size).length) {
                    return size;
                }
            }

            return null;
        }

        /**
         * floatThead: fixed + scrollContainer (see datagrid.ts). Destroy before
         * emptying the snippet — fixed clones live on the scroll host.
         */
        function destroySideDialogFloatThead() {
            if (!$.fn.floatThead) {
                return;
            }
            // Scoped: do not touch main-page grids
            $('.nais-sd-window table.floatedTable, .nais-sd-window table.nais-datagrid').each(function () {
                const $table = $(this);
                if ($table.hasClass('floatThead-table')) {
                    return;
                }
                if ($table.data('floatThead-attached')) {
                    try {
                        $table.floatThead('destroy');
                    } catch (e) { /* ignore */ }
                }
                const $fth = $table.data('nais-fth-container');
                if ($fth && $fth.length) {
                    $fth.remove();
                }
                $table.removeData('nais-fth-container');
                $table.removeData('nais-fth-uid');
            });
            $('.nais-sd-container > .floatThead-container, .nais-sd-panel__body > .floatThead-container').remove();
        }

        function initSideDialogFloatThead() {
            if (typeof window.init_datagrid_floated_tables === 'function') {
                window.init_datagrid_floated_tables();
            }
        }

        /**
         * After Nette inserts snippets (when the DOM is up to date).
         * @param {JQuery|undefined} $trigger
         */
        function afterSideDialogPayload($trigger) {
            relocateSideDialogSnippet();
            resolveAndApplySize($trigger);
            initSideDialogForms();
            initSideDialogFloatThead();
            // Datagrid init in snippet callbacks may run after this tick.
            setTimeout(initSideDialogFloatThead, 0);
        }

        /**
         * Relocate copies innerHTML — the form node Nette.initForm already wired is gone.
         */
        function initSideDialogForms() {
            let host = getSnippetHost().get(0);
            if (host && typeof window.initNetteForms === 'function') {
                window.initNetteForms(host);
            }
        }

        /**
         * After AJAX the snippet wins; before content loads use the link (data-nais-sd-size).
         * @param {JQuery|undefined} $trigger
         */
        function resolveSize($trigger) {
            return resolveSizeFromSnippet() || readSizeFromElement($trigger) || null;
        }

        /**
         * Build CSS class string for the side dialog window.
         * @param {'wide'|'compact'|null|undefined} size
         * @returns {string}
         */
        function buildWindowClassAttr(size) {
            let classes = 'nais-sd-window';
            size = normalizeSize(size);
            if (size) {
                classes += ' nais-sd-window--' + size;
            }
            return classes;
        }

        /**
         * Apply wide/compact/modal size classes and data attribute on the window element.
         * @param {'wide'|'compact'|'modal'|null|undefined} size
         */
        function applyWindowSize(size) {
            let $w = $('.nais-sd-window');
            if (!$w.length) {
                return;
            }
            $window = $w;
            $w.removeClass(SIZE_CLASSES.join(' '));
            size = normalizeSize(size);
            if (size) {
                $w.addClass('nais-sd-window--' + size);
                $w.attr('data-nais-sd-size', size);
            } else {
                $w.removeAttr('data-nais-sd-size');
            }

            setCloseButtonIcon(size === 'modal' ? 'x' : 'chevron-right', $w);
        }

        /**
         * Lucide close-tab glyph (chevron for panel, x for modal).
         * createIcons replaces <i data-lucide> with <svg>, so always rebuild the host.
         * @param {string} iconName
         * @param {JQuery} [$root]
         */
        function setCloseButtonIcon(iconName, $root) {
            let $btn = ($root && $root.length ? $root : $window).find('.nais-sd-close-button');
            if (!$btn.length) {
                return;
            }
            $btn.empty().append($('<i>', {
                'data-lucide': iconName,
                'aria-hidden': 'true',
            }));
            if (typeof window.initLucideIcons === 'function') {
                window.initLucideIcons($btn.get(0));
            }
        }

        /**
         * @param {JQuery|undefined} $trigger
         */
        function resolveAndApplySize($trigger) {
            applyWindowSize(resolveSize($trigger));
        }

        /**
         * Create side dialog elements and append them to body
         * @param {'wide'|'compact'|null|undefined} initialSize
         */
        function createElements(initialSize) {
            initialSize = normalizeSize(initialSize);
            // background element
            $background = $('<div>', {
                class: 'nais-sd-background',
            });
            // window element — class + data in HTML immediately (width before AJAX)
            $window = $('<div>', {
                class: buildWindowClassAttr(initialSize),
                'data-nais-sd-size': initialSize || undefined,
            });
            // close button — Lucide via data-lucide (class on <button> breaks createIcons)
            $closeButton = $('<button>', {
                type: 'button',
                class: 'nais-sd-close-button',
                'aria-label': 'Close',
            });
            // snippet element
            $snippet = $('<div>', {
                id: SNIPPET_ID
            });

            // add close button to dialog window
            $closeButton.appendTo($window);
            setCloseButtonIcon(initialSize === 'modal' ? 'x' : 'chevron-right', $window);

            // insert div.nais-sd-container with snippet inside
            $window.append($('<div>', {
                class: 'nais-sd-container'
            }).html($snippet));

            // add the same close event to close button and dark background
            $closeButton.add($background).on('click', clickToCloseDialog);

            /**
             * Close button and background click handler
             */
            function clickToCloseDialog() {
                closeSideDialog();
                if (historyEnabled) {
                    history.pushState(null, null, '#'); // push null as history state object and empty hash part
                }
            }

            // append elements to body
            $background.appendTo('body');
            $window.appendTo('body');
        }

        /**
         * Open dialog with specific url
         * @param url
         */
        function openSideDialog(url, $trigger) {
            let initialSize = readSizeFromElement($trigger);
            if ($('.nais-sd-window').length === 0) {
                createElements(initialSize);
            } else {
                applyWindowSize(resolveSize($trigger) || initialSize);
            }
            // show semi-transparent background
            $background.fadeIn(200);

            // BS5 uses .tooltip.show (not .in); also dispose trigger tip so it does not stick open
            hideOpenTooltips($trigger);

            trigger('opening');

            let size = resolveSize($trigger) || initialSize;
            let onOpened = function () {
                // Send AJAX request to provided URL. Cooperation with nette snippets and ajax handling is needed
                // Call $this->sideDialogAjaxHandler(); in presenter's action method
                trigger('open');
                $.nette.ajax({
                    url,
                    success: function () {
                        afterSideDialogPayload($trigger);
                    }
                });
            };

            if (size === 'modal') {
                applyWindowSize('modal');
                $window.stop(true, true).fadeIn(200, onOpened);
            } else {
                // slide in side dialog from right
                $window.show('slide', {
                    direction: 'right'
                }, function afterSlideOpen() {
                    // jQuery UI leaves display:block; flex is required for height lock.
                    $window.css('display', 'flex');
                    onOpened();
                });
            }
        }

        /**
         * Click handler for links
         * @returns {boolean}
         */
        function clickToOpenDialog() {
            let url = $(this).attr('href');
            if ($(this).data('sd-history') === 'on') {
                // enable working with browser's history
                historyEnabled = true;
            }

            lastOpenTrigger = $(this);
            hideOpenTooltips(lastOpenTrigger);
            openSideDialog(url, lastOpenTrigger);

            if (historyEnabled) {
                history.pushState(
                    {
                        naisSideDialog: url,
                        naisSdSize: resolveSize(lastOpenTrigger)
                    },
                    null,
                    `#${URL_PARAM_NAME}=${url}`
                );
            }

            // do not go to url
            return false;
        }

        /**
         * Close dialog and empty its contents
         */
        function closeSideDialog() {
            destroySideDialogFloatThead();
            if ($snippet !== undefined) {
                $snippet.html('');
            }
            let closingSize = normalizeSize($window && $window.attr('data-nais-sd-size'));
            trigger('closing');

            let afterHide = function () {
                applyWindowSize(null);
                trigger('close');
                // Re-bind tooltips disposed on the open trigger (e.g. workspace bug/notify buttons)
                if (typeof window.initBootstrapTooltips === 'function') {
                    window.initBootstrapTooltips();
                }
            };

            if ($window !== undefined) {
                if (closingSize === 'modal') {
                    $window.stop(true, true).fadeOut(200, afterHide);
                } else {
                    // slide back
                    $window.hide('slide', {
                        direction: 'right'
                    }, afterHide);
                }
            }
            if ($background !== undefined) {
                $background.fadeOut(200);
            }
        }

        /**
         * history.popState event handler - when user clicks on back or forward button
         * @param e jQuery event
         */
        function loadFromHistoryState(e) {
            let state = e.originalEvent.state; // load pushed state object
            if (state !== null && state.naisSideDialog !== undefined) {
                let $trigger = null;
                if (state.naisSdSize) {
                    $trigger = $('<a>').data('naisSdSize', state.naisSdSize);
                }
                openSideDialog(state.naisSideDialog, $trigger);
            } else if (state === null && window.location.hash === null) {
                // no state object? close dialog.
                closeSideDialog();
            }
        }

        /**
         * Public method for open Side dialog
         * @param {string} url
         * @param {boolean} [useHistory=true]
         * @param {'wide'|'compact'|null} [size=null] — panel width (no URL heuristics)
         */
        dialog.open = function (url, useHistory = true, size = null) {
            let $trigger = size ? $('<a>').data('naisSdSize', size) : null;
            openSideDialog(url, $trigger);

            if (useHistory) {
                historyEnabled = true;
                history.pushState(
                    {
                        naisSideDialog: url,
                        naisSdSize: normalizeSize(size)
                    },
                    null,
                    `#${URL_PARAM_NAME}=${url}`
                );
            }
        }

        /**
         * Public method for close Side dialog
         */
        dialog.close = function () {
            closeSideDialog();
            if (historyEnabled) {
                history.pushState(null, null, '#'); // push null as history state object and empty hash part
            }
        }

        dialog.on = function (name, listener) {
            if (!events[name]) {
                events[name] = [];
            }

            events[name].push(listener);
            return dialog;
        }

        dialog.off = function (name) {
            if (!events[name]) {
                return dialog;
            }
            events[name] = [];
            return dialog;
        }

        function trigger(name, data) {
            if (!events[name]) {
                return;
            }

            const fireCallbacks = (callback) => {
                callback(data);
            };

            events[name].forEach(fireCallbacks);
        }

        /**
         * Header submit buttons live outside <form> (form="…"). nette.ajax only binds
         * button.ajax inside a form, so wire them explicitly to keep errors in the panel.
         */
        function bindSideDialogFormAjaxSubmit() {
            $(document).on(
                'click.naisSdAjaxSubmit',
                '.nais-sd-window .nais-sd-panel__actions button[type="submit"][form]',
                function (e) {
                    let $btn = $(this);
                    let formId = $btn.attr('form');
                    if (!formId) {
                        return;
                    }
                    let $form = $('#' + formId.replace(/(:|\.|\[|\]|,|=|@)/g, '\\$1'));
                    if (!$form.length || !$form.hasClass('ajax')) {
                        return;
                    }
                    e.preventDefault();
                    e.stopPropagation();
                    $form.get(0)['nette-submittedBy'] = this;
                    $.nette.ajax({
                        url: $form.attr('action') || window.location.pathname + window.location.search,
                        type: ($form.attr('method') || 'post').toLowerCase(),
                        nette: {
                            e: e,
                            ui: this,
                            el: $btn,
                            isForm: false,
                            isSubmit: true,
                            isImage: false,
                            form: $form
                        }
                    });
                }
            );
        }

        // handle history popstate event
        $(window).on('popstate.sideDialog', loadFromHistoryState);
        // handle all .nais-side-dialog links click
        $(document).on('click', '.nais-side-dialog', clickToOpenDialog);
        bindSideDialogFormAjaxSubmit();
        // Nette inserts snippets after the AJAX success callback
        $(document).on('nette:snippets', function () {
            if (!$('.nais-sd-window:visible').length) {
                return;
            }
            afterSideDialogPayload(lastOpenTrigger);
        });

        setTimeout(function () {
            let hash = window.location.hash;

            // if there is hash part in url with side dialog parameter url, open url.
            if (hash.substring(1, URL_PARAM_NAME.length + 1) === URL_PARAM_NAME) { // +1 for "#" character
                let url = hash.substring(URL_PARAM_NAME.length + 2); // +2 for "#" and "=" characters

                // hash part in url means that history editing is enabled
                historyEnabled = true;

                // update actual history state object with provided url
                history.replaceState(
                    {
                        naisSideDialog: url,
                        naisSdSize: null
                    },
                    null
                );

                // open dialog — size applied after the snippet loads
                openSideDialog(url);
            }
        }, 0);


        return this;
    }
    window.naisSideDialog = $().naisSideDialog();
})(jQuery);